import { getFlavorHashtags } from 'utils/api/flavors.api';
import { useQuery } from 'react-query';

function queryFn({ queryKey }) {
    return getFlavorHashtags({
        category: queryKey[1].category,
        country: queryKey[1].country,
        flavor: queryKey[1].flavor,
    });
}

export const getQueryKey = ({ category, country, flavor }) => {
    return [
        'flavor-hashtags',
        {
            category,
            country,
            flavor,
        },
    ];
};

const useFlavorHashtags = ({ category, country, flavor, enabled = true }) => {
    const queryKey = getQueryKey({
        category,
        country,
        flavor,
    });
    const query = useQuery(queryKey, queryFn, {
        enabled,
        staleTime: Infinity,
    });
    return query;
};

export default useFlavorHashtags;
